import { useRecordContext } from "ra-core";
import type { Contact } from "../types";
import { EmailListSubscriptionsWidget } from "./EmailListSubscriptionsWidget";
import { extractEmailsFromContact } from "./encharge/api";

export const ContactEmailListSubscriptions = () => {
  const record = useRecordContext<Contact>();
  if (!record) return null;

  const emails = extractEmailsFromContact(record.email_jsonb);

  return <EmailListSubscriptionsWidget emails={emails} />;
};
